<template>
  <div class="mw-pagination">
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'mw-pagination',
    data(){
      var ps = [20, 50, 100,250,500,1000];
      if(ps.indexOf(this.pageSize) == -1){
        ps.unshift(this.pageSize);
      }
      return {
        pageSizes:ps
      }
    },
    props: {
      total: {
        type: Number,
        default: 0
      },
      currentPage: {
        type: Number,
        default: 1
      },
      pageSize:{
        type: Number,
        default: 20
      }
    },
    methods:{
      "currentChange"(val){
        this.$emit('current-change',val);
      },
      "sizeChange"(val){
        this.$emit('size-change',val);
      }
    },
    watch: {
        pageSize(val) {
          if(this.pageSizes.indexOf(val)==-1){
            this.pageSizes.unshift(val)
          }
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/pagination/index.vue